export const NYSEHoursOfOperations = {
    "hour_aligned": false,
    "market_tz": "America/New_York",
    "name": "NYSE",
    "rules": [
        // First open up the regular trading times
        // Note that sat and sun (in this example) are always closed because
        // everything is closed by default and we didn't explicitly open
        // them.
        { "dayofweek": 1, "open": "09:30", "close": "16:00" }, // mon
        { "dayofweek": 2, "open": "09:30", "close": "16:00" },
        { "dayofweek": 3, "open": "09:30", "close": "16:00" },
        { "dayofweek": 4, "open": "09:30", "close": "16:00" },
        { "dayofweek": 5, "open": "09:30", "close": "16:00" }, // fri

        // After Hours premarket
        { "dayofweek": 1, "open": "08:00", "close": "09:30", name: "pre" }, // mon
        { "dayofweek": 2, "open": "08:00", "close": "09:30", name: "pre" },
        { "dayofweek": 3, "open": "08:00", "close": "09:30", name: "pre" },
        { "dayofweek": 4, "open": "08:00", "close": "09:30", name: "pre" },
        { "dayofweek": 5, "open": "08:00", "close": "09:30", name: "pre" }, // fri

        // After Hours post
        { "dayofweek": 1, "open": "16:00", "close": "20:00", name: "post" }, // mon
        { "dayofweek": 2, "open": "16:00", "close": "20:00", name: "post" },
        { "dayofweek": 3, "open": "16:00", "close": "20:00", name: "post" },
        { "dayofweek": 4, "open": "16:00", "close": "20:00", name: "post" },
        { "dayofweek": 5, "open": "16:00", "close": "20:00", name: "post" }, // fri

        // Now Monday thru Friday is open. Close any exceptions

        // always closed on Christmas
        { "date": "*-12-25", "open": "00:00", "close": "00:00" },

        // always closed on 4th of July
        { "date": "*-07-04", "open": "00:00", "close": "00:00" },

        // always close on new years day
        { "date": "*-01-01", "open": "00:00", "close": "00:00" },

        // Some holidays are observed on different days each year or if
        // the day falls on a weekend. Each of those rules must be specified.
        { "date": "2012-01-02", "open": "00:00", "close": "00:00" },

        // As a special case if no open and close attributes are set they
        // will be assumed "00:00" and "00:00" respectively
        { "date": "2017-01-02" },

        { "date": "2016-01-18" },
        { "date": "2016-02-15" },
        { "date": "2016-03-25" },
        { "date": "2016-05-30" },
        { "date": "2016-09-05" },
        { "date": "2016-11-24" },
        { "date": "2016-11-25", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2016-11-25", "open": "9:30", "close": "13:00" },
        { "date": "2016-12-26" },

        { "date": "2015-01-19" },
        { "date": "2015-02-16" },
        { "date": "2015-04-03" },
        { "date": "2015-05-25" },
        { "date": "2015-07-03" },
        { "date": "2015-09-07" },
        { "date": "2015-11-26" },
        { "date": "2015-11-27", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2015-11-27", "open": "9:30", "close": "13:00" },
        { "date": "2015-12-24", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2015-12-24", "open": "9:30", "close": "13:00" },

        { "date": "2014-01-20" },
        { "date": "2014-02-17" },
        { "date": "2014-04-18" },
        { "date": "2014-05-26" },
        { "date": "2014-09-01" },
        { "date": "2014-11-27" },
        { "date": "2014-07-03", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2014-07-03", "open": "9:30", "close": "13:00" },
        { "date": "2014-11-28", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2014-11-28", "open": "9:30", "close": "13:00" },
        { "date": "2014-12-24", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2014-12-24", "open": "9:30", "close": "13:00" },

        { "date": "2013-01-21" },
        { "date": "2013-02-18" },
        { "date": "2013-03-29" },
        { "date": "2013-05-27" },
        { "date": "2013-09-02" },
        { "date": "2013-11-28" },
        { "date": "2013-07-03", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2013-07-03", "open": "9:30", "close": "13:00" },
        { "date": "2013-11-29", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2013-11-29", "open": "9:30", "close": "13:00" },
        { "date": "2013-12-24", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2013-12-24", "open": "9:30", "close": "13:00" },

        { "date": "2012-01-16" },
        { "date": "2012-02-20" },
        { "date": "2012-04-06" },
        { "date": "2012-05-28" },
        { "date": "2012-09-03" },
        { "date": "2012-10-29" },
        { "date": "2012-10-30" },
        { "date": "2012-11-22" },
        { "date": "2012-07-03", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2012-07-03", "open": "9:30", "close": "13:00" },
        { "date": "2012-11-23", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2012-11-23", "open": "9:30", "close": "13:00" },
        { "date": "2012-12-24", "open": "8:00", "close": "9:30", name: "pre" },
        { "date": "2012-12-24", "open": "9:30", "close": "13:00" }
    ]
};